import { InputBaseClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiInputBase: Record<InputBaseClassKey, CSSProperties> = {
  disabled: {},
  root: { '&.Mui-disabled': { color: 'rgba(0, 0, 0, 0.87)' } },
  adornedEnd: {},
  adornedStart: {},
  colorSecondary: {},
  error: {},
  focused: {},
  formControl: {},
  fullWidth: {},
  input: {},
  inputAdornedEnd: {},
  inputAdornedStart: {},
  inputHiddenLabel: {},
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {},
  marginDense: {},
  multiline: {},
};
